import "./App.css";
import HomeScreen from "./Pages/HomeScreen/HomeScreen";
import IntroScreen from "./Pages/SpalshScreen/SplashScreen";

function App() {
  return (
    <div className="App">
      <IntroScreen />
    </div>
  );
}

export default App;
